import CreateAccount from './create-account-view';

export default CreateAccount;
